// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import CountriesVATJson from "src/assets/countries-VAT.json";

function getVATRateByCountry(country) {
  let normalizedCountry = country.toLowerCase().trim();
  return Stdlib_Option.map(Object.entries(CountriesVATJson).find(param => param[0].toLowerCase() === normalizedCountry), param => param[1]);
}

export {
  getVATRateByCountry,
}
/* src/assets/countries-VAT.json Not a pure module */
